// @ts-nocheck
import React from "react";
import { Document, Page, Text, View, StyleSheet, PDFViewer, PDFDownloadLink, Font } from "@react-pdf/renderer";

Font.register({
    family: "Roboto",
    fonts: [
      { src: "/fonts/Roboto-Regular.ttf", fontWeight: "normal" },
      { src: "/fonts/Roboto-Bold.ttf", fontWeight: "bold" },
    ],
  });

const styles = StyleSheet.create({
    page: {
        padding: 30,
        fontSize: 10,
        fontFamily: "Roboto",
    },
    row: {
        flexDirection: "row",
        justifyContent: "space-between",
    },
    leftText: {
        width: "60%",
    },
    rightTextBlock: {
        textAlign: "right",
        fontSize: 7,
    },
    bold: {
        fontWeight: "bold",
    },
    innBlock: {
        flexDirection: "row",
        alignItems: "center",
        marginTop: 5,
    },
    innLabel: {
        fontWeight: "bold",
        fontSize: 8,
        marginRight: 5,
    },
    innValue: {
        border: "1px solid black",
        paddingTop: 4,
        paddingBottom: 4,
        fontSize: 9,
        width: 115,

        textAlign: "center",
    },
    flex: {
        display: "flex",
    },
});

const InvoicePDF = ({data}) => (
    <Document>
        <Page size="A4" style={styles.page}>
            <View style={styles.topRow}>
                {/* Справа — Приложение */}
                <View style={styles.rightBlock}>
                    <View style={styles.rightTextBlock}>
                        <Text>Приложение 26</Text>
                        <Text>к приказу Министра финансов</Text>
                        <Text>Республики Казахстан</Text>
                        <Text>от 20.12.2012 года № 562</Text>
                        <Text>Форма 3-2</Text>
                    </View>
                </View>
                <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                    <View style={styles.organizationRow}>
                        <Text style={{ fontSize: 7 }}>
                            Организация (индивидуальный предприниматель)
                        </Text>
                    </View>
                    {/* Слева на уровне "Организация" — ИИН/БИН */}
                    <View style={styles.leftBlock}>
                        <View style={styles.innBlock}>
                            <Text style={styles.innLabel}>ИИН/БИН</Text>
                            <Text style={styles.innValue}>{data?.tradePoint?.bin || '-'}</Text>
                        </View>
                    </View>
                </View>

                {/* заголовок и таблица */}
                <View
                    style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        marginTop: 20,
                    }}
                >
                    {/* Заголовок по центру */}
                    <View
                        style={{
                            alignItems: "center",
                            alignContent: "center",
                            marginTop: 20,
                            fontWeight: "bold",
                            justifyContent: "center",
                            fontSize: 9,
                        }}
                    >
                        <Text style={{ fontWeight: "bold", fontSize: 7, marginLeft: "40%" }}>
                            НАКЛАДНАЯ  НА ОТПУСК ЗАПАСОВ  НА СТОРОНУ
                        </Text>
                    </View>

                    {/* Таблица с номером и датой */}
                    <View
                        style={{
                            border: "1px solid black",
                            fontSize: 7,
                            width: 115,
                        }}
                    >
                        {/* Шапка */}
                        <View style={{ flexDirection: "row" }}>
                            <View
                                style={{
                                    width: "50%",
                                    borderRight: "1px solid black",
                                    padding: 4,
                                    fontWeight: "bold",
                                    textAlign: "center",
                                }}
                            >
                                <Text>Номер</Text>
                            </View>
                            <View
                                style={{
                                    width: "50%",
                                    padding: 4,
                                    fontWeight: "bold",
                                    textAlign: "center",
                                }}
                            >
                                <Text>Дата</Text>
                            </View>
                        </View>

                        {/* Значения */}
                        <View style={{ flexDirection: "row" }}>
                            <View
                                style={{
                                    width: "50%",
                                    borderRight: "1px solid black",
                                    borderTop: "1px solid black",
                                    padding: 4,
                                    textAlign: "center",
                                }}
                            >
                                <Text style={{ fontSize: 6.5, textAlign: "center" }}>
                                    {data?.id || '-'}
                                </Text>
                            </View>
                            <View
                                style={{
                                    width: "50%",
                                    borderTop: "1px solid black",
                                    padding: 4,
                                    textAlign: "center",
                                }}
                            >
                                <Text>{data?.createdAt || '-'}</Text>
                            </View>
                        </View>
                    </View>
                </View>

                {/* Таблицаааааа 11111 */}
                <View style={{ marginTop: 20 }}>
                    {/* Шапка */}
                    <View style={{ flexDirection: "row" }}>
                        {[
                            "Организация (индивидуальный предприниматель) - отправитель",
                            "Организация (индивидуальный предприниматель)- получатель",
                            "Ответственный за поставку (Ф.И.О.)",
                            "Транспортная организация",
                            "Товарно - транспортная накладная (номер, дата)",
                        ].map((header, i) => (
                            <View
                                key={i}
                                style={{
                                    width: "20%",
                                    borderRight: i < 4 ? "1px solid black" : "none",
                                    padding: 4,
                                    fontWeight: "bold",
                                    textAlign: "center",
                                }}
                            >
                                <Text>{header}</Text>
                            </View>
                        ))}
                    </View>

                    {/* Значения */}
                    <View style={{ flexDirection: "row" }}>
                        {[
                            data?.tradePoint?.name || '-',
                            data?.userEmail || '-',
                            "Сергей Гусаков",
                            "", // пусто
                            "", // пусто
                        ].map((value, i) => (
                            <View
                                key={i}
                                style={{
                                    width: "20%",
                                    borderRight: i < 4 ? "1px solid black" : "none",
                                    padding: 4,
                                    textAlign: "center",
                                }}
                            >
                                <Text>{value}</Text>
                            </View>
                        ))}
                    </View>
                </View>

                {/* Таблицаааааа 222222 */}
                <View style={{ marginTop: 20 }}>
                    {/* Шапка */}
                    <View style={{ flexDirection: "row" }}>
                        <View style={{ width: "7%", borderRight: "1px solid black", padding: 4 }}><Text style={{ fontWeight: "bold", textAlign: "center" }}>Номер{"\n"}по порядку</Text></View>
                        <View style={{ width: "18%", borderRight: "1px solid black", padding: 4 }}><Text style={{ fontWeight: "bold", textAlign: "center" }}>Наименование, характеристика</Text></View>
                        <View style={{ width: "14%", borderRight: "1px solid black", padding: 4 }}><Text style={{ fontWeight: "bold", textAlign: "center" }}>Номенклатурный номер</Text></View>
                        <View style={{ width: "10%", borderRight: "1px solid black", padding: 4 }}><Text style={{ fontWeight: "bold", textAlign: "center" }}>Единица измерения</Text></View>
                        {/* Объединённая колонка Количество */}
                        <View style={{ width: "16%", borderRight: "1px solid black" }}>
                            <View style={{ borderBottom: "1px solid black", padding: 4 }}><Text style={{ fontWeight: "bold", textAlign: "center" }}>Количество</Text></View>
                            <View style={{ flexDirection: "row" }}>
                                <View style={{ width: "50%", borderRight: "1px solid black", padding: 2 }}><Text style={{ fontWeight: "bold", fontSize: 7, textAlign: "center" }}>подлежит отпуску</Text></View>
                                <View style={{ width: "50%", padding: 2 }}><Text style={{ fontWeight: "bold", fontSize: 7, textAlign: "center" }}>отпущено</Text></View>
                            </View>
                        </View>
                        
                        <View style={{ width: "12.5%", borderRight: "1px solid black", padding: 4 }}><Text style={{ fontWeight: "bold", textAlign: "center" }}>Сумма с НДС, в тенге</Text></View>
                        <View style={{ width: "12.5%", padding: 4 }}><Text style={{ fontWeight: "bold", textAlign: "center" }}>Сумма НДС, в тенге</Text></View>
                    </View>

                    {/* Строки из массива */}
                    {data?.items?.map((row, i) => (
                        <View key={i} style={{ flexDirection: "row", borderTop: "1px solid black" }}>
                            <View style={{ width: "7%", borderRight: "1px solid black", padding: 4, textAlign: "center" }}><Text>{i + 1}</Text></View>
                            <View style={{ width: "18%", borderRight: "1px solid black", padding: 4 }}><Text>{row.name}</Text></View>
                            <View style={{ width: "14%", borderRight: "1px solid black", padding: 4 }}><Text>{row.barcode}</Text></View>
                            <View style={{ width: "10%", borderRight: "1px solid black", padding: 4, textAlign: "center" }}><Text>1 шт.</Text></View>
                            <View style={{ width: "8%", borderRight: "1px solid black", padding: 4, textAlign: "center" }}><Text>{row.quantity}</Text></View>
                            <View style={{ width: "8%", borderRight: "1px solid black", padding: 4, textAlign: "center" }}><Text>{row.quantity - (row.reductCount || 0)}</Text></View>
                            <View style={{ width: "10%", borderRight: "1px solid black", padding: 4 }}><Text>{row.price || '-'}</Text></View>
                            <View style={{ width: "12.5%", padding: 4 }}><Text>{row.vat || '-'}</Text></View>
                        </View>
                    ))}
                </View>

                {/* Блок подписей */}
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        flexWrap: "wrap",
                        fontSize: 9,
                        marginTop: 23,
                    }}
                >
                    <Text style={{ fontWeight: "bold" }}>
                        Всего отпущено количество (прописью)
                    </Text>

                    <View
                        style={{
                            borderBottom: "1px solid black",
                            width: 150,
                            marginHorizontal: 6,
                            height: 10,
                        }}
                    />

                    <Text style={{ fontWeight: "bold" }}>
                        на сумму (прописью), в тенге
                    </Text>

                    <View
                        style={{
                            borderBottom: "1px solid black",
                            flexGrow: 1,
                            height: 10,
                            marginLeft: 6,
                        }}
                    />
                </View>

                <View
                    style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginTop: 20,
                        fontSize: 8,
                    }}
                >
                    {/* Левая часть — подписи */}
                    <View style={{ width: "50%" }}>


                        <View style={{ flexDirection: "row", alignItems: "flex-start", marginTop: 10, fontSize: 8 }}>
                            <Text style={{ marginRight: 6 }}>Отпуск разрешил</Text>

                            {/* Блок с линиями и подписями */}
                            <View style={{ position: "relative" }}>
                                {/* Линии */}
                                <View style={{ flexDirection: "row" }}>
                                    <Text>____________________</Text>
                                    <Text style={{ marginHorizontal: 6 }}>/</Text>
                                    <Text>__________</Text>
                                    <Text style={{ marginHorizontal: 6 }}>/</Text>
                                    <Text>______________</Text>
                                </View>

                                {/* Подписи под линиями (абсолютно позиционированы) */}
                                <View style={{ position: "absolute", top: 12, flexDirection: "row" }}>
                                    <Text style={{ width: 55, textAlign: "center", fontSize: 7 }}>должность</Text>
                                    <Text style={{ width: 20 }}></Text>
                                    <Text style={{ width: 55, textAlign: "center", fontSize: 7 }}>подпись</Text>
                                    <Text style={{ width: 7 }}></Text>
                                    <Text style={{ width: 55, textAlign: "center", fontSize: 7 }}>расшифровка</Text>
                                </View>
                            </View>
                        </View>



                    </View>

                    {/* Правая часть — доверенность */}
                    <View style={{ width: "50%", alignItems: "flex-end" }}>
                        <View style={{ flexDirection: "row", flexWrap: "wrap", fontSize: 8, marginTop: 10 }}>
                            <Text>По доверенности № </Text>
                            <Text>__________</Text>
                            <Text> от «</Text>
                            <Text>___</Text>
                            <Text>» </Text>
                            <Text>______________</Text>
                            <Text> 20</Text>
                            <Text>__</Text>
                            <Text> года</Text>
                        </View>

                        <View
                            style={{
                                flexDirection: "row",
                                marginTop: 6,
                            }}
                        >
                            <Text>выданной _____________________________________________________</Text>
                        
                        </View>
                    </View>
                </View>

                <View
                    style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginTop: 10,
                        fontSize: 8,
                    }}
                >
                    {/* Левая часть — подписи */}
                    <View style={{ width: "50%" }}>


                        <View style={{ flexDirection: "row", alignItems: "flex-start", marginTop: 6, fontSize: 8 }}>
                            <Text style={{ marginRight: 6 }}>Главный бухгалтер</Text>

                            {/* Блок с линиями и подписями */}
                            <View style={{ position: "relative" }}>
                                {/* Линии */}
                                <View style={{ flexDirection: "row" }}>
                                    <Text>____________________</Text>
                                    <Text style={{ marginHorizontal: 6 }}>/</Text>
                                    <Text>________________________</Text>
                                </View>

                                {/* Подписи под линиями (абсолютно позиционированы) */}
                                <View style={{ position: "absolute", top: 12, flexDirection: "row" }}>
                                    <Text style={{ width: 55, textAlign: "center", fontSize: 7 }}>подпись</Text>
                                    <Text style={{ width: 35 }}></Text>
                                    <Text style={{ width: 80, textAlign: "center", fontSize: 7 }}>расшифровка подписи</Text>
                                  
                                </View>
                            </View>
                        </View>



                    </View>

                    {/* Правая часть — доверенность */}
                    <View style={{ width: "50%", alignItems: "flex-end" }}>
                    <View style={{ flexDirection: "row", alignItems: "flex-start", marginTop: 6, fontSize: 8 }}>
                            <Text style={{ marginRight: 6 }}>Запасы получил</Text>

                            {/* Блок с линиями и подписями */}
                            <View style={{ position: "relative" }}>
                                {/* Линии */}
                                <View style={{ flexDirection: "row" }}>
                                    <Text>__________________</Text>
                                    <Text style={{ marginHorizontal: 6 }}>/</Text>
                                    <Text>________________________</Text>
                                </View>

                                {/* Подписи под линиями (абсолютно позиционированы) */}
                                <View style={{ position: "absolute", top: 12, flexDirection: "row" }}>
                                    <Text style={{ width: 55, textAlign: "center", fontSize: 7 }}>подпись</Text>
                                    <Text style={{ width: 35 }}></Text>
                                    <Text style={{ width: 80, textAlign: "center", fontSize: 7 }}>расшифровка подписи</Text>
                                  
                                </View>
                            </View>
                        </View>
                    </View>
                </View>

                <View
                    style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginTop: 10,
                        fontSize: 8,
                    }}
                >
                    {/* Левая часть — подписи */}
                    <View style={{ width: "50%" }}>


                        <View style={{ flexDirection: "row", alignItems: "flex-start", marginTop: 6, fontSize: 8 }}>
                            <Text style={{ marginRight: 6 }}>Отпустил</Text>

                            {/* Блок с линиями и подписями */}
                            <View style={{ position: "relative" }}>
                                {/* Линии */}
                                <View style={{ flexDirection: "row" }}>
                                    <Text>____________________</Text>
                                    <Text style={{ marginHorizontal: 6 }}>/</Text>
                                    <Text>________________________</Text>
                                </View>

                                {/* Подписи под линиями (абсолютно позиционированы) */}
                                <View style={{ position: "absolute", top: 12, flexDirection: "row" }}>
                                    <Text style={{ width: 55, textAlign: "center", fontSize: 7 }}>подпись</Text>
                                    <Text style={{ width: 35 }}></Text>
                                    <Text style={{ width: 80, textAlign: "center", fontSize: 7 }}>расшифровка подписи</Text>
                                  
                                </View>
                            </View>
                        </View>



                    </View>
                </View>
            </View>
        </Page>
    </Document>
);


export default InvoicePDF;
